import { FFormChildMDP } from "@/components/form/FFormMDP";
import FBudgetMiniFormMDP from "@/components/form/field/FBudgetMiniFormMDP";
import FCurrencyFieldMDP from "@/components/form/field/FCurrencyFieldMDP";
import FMiniFormMDP from "@/components/form/field/FMiniFormMDP";
import FTextareaMDP from "@/components/form/field/FTextareaMDP";


export default class FHardshipReasonFMiniFormMDP extends FMiniFormMDP {
  childMDP = new FFormChildMDP();
  taskRoot: any;
  parent: any;
  constructor({ taskRoot, parent }: { taskRoot: any; parent: any }) {
    super({
      parentMDP: new FFormChildMDP(),
      disabled: taskRoot.taskDisabled,
      label: "Reason For Hardship",
      dataSelectorKey: "taskOutput.budgetInfo",
      mandatory: true,
      boundaryClass: "col-5",
    });
    this.taskRoot = taskRoot;
    this.parent = parent;

    this.addField(
      new FTextareaMDP({
        parentMDP: this.childMDP,
        label: "Reason For Hardship",
        dataSelectorKey: "hardshipReason",
        mandatory: true,
        rows: '7',
        autoGrow: false
      })
    );
  }
}
